import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { animated, useSpring } from "react-spring";
import { Icon } from "../../Icon/Icon";
import { AdminMenuEntry } from "../AdminMenuEntry/AdminMenuEntry";
import "./AdminMenu.css";

export const AdminMenu = ({ role }) => {
  const { t } = useTranslation();
  const [toggle, triggerAnimation] = useState(true);
  const animationProps = useSpring({ width: toggle ? "210px" : "100px" });

  return (
    <animated.div className="AdminMenu" style={animationProps}>
      <animated.div className="AdminMenu__logo" style={animationProps}>
        <Icon name="iconEflow" width={40} height={40} />
      </animated.div>
      <AdminMenuEntry
        label={t("menu.myProfile")}
        path="profile"
        icon="menuEmployee"
        activeIcon="menuEmployeeActive"
        iconWidth={22}
        expanded={toggle}
      />
      {role === "SUPERADMIN" && (
        <AdminMenuEntry
          label={t("menu.distributors")}
          path="distributors"
          icon="menuDistributors"
          activeIcon="menuDistributorsActive"
          iconWidth={18}
          expanded={toggle}
        />
      )}
      <AdminMenuEntry
        label={t("menu.accounts")}
        path="accounts"
        icon="menuAccounts"
        activeIcon="menuAccountsActive"
        iconWidth={20}
        expanded={toggle}
      />
      <AdminMenuEntry
        label={t("menu.users")}
        path="users"
        icon="menuUsers"
        activeIcon="menuUsersActive"
        iconWidth={22}
        expanded={toggle}
      />
      <AdminMenuEntry
        label={t("menu.administration")}
        path="administration"
        icon="menuAdministration"
        activeIcon="menuAdministrationActive"
        iconWidth={23}
        expanded={toggle}
      />

      <div
        className={
          !toggle
            ? "AdminMenu__toggle"
            : "AdminMenu__toggle AdminMenu__toggle--toggled"
        }
        onClick={() => triggerAnimation(!toggle)}
      >
        <Icon name="iconArrowRight" width={9} height={15} />
      </div>
    </animated.div>
  );
};
